import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { getIncomeTableFormGroup } from '@app/components/investor-qualification/knowledge-test-form/knowledge-test-form.helper';
import { IncomeTable } from '@app/components/investor-qualification/knowledge-test-form/knowledge-test.models';

export interface investorStatementFormGroup {
  q1OwnsTransferableSecurities: FormControl<boolean>;
  q2OwnsCrowdfundingAssetsOrLoans: FormControl<boolean>;
  q3HasCrowdfundingInvestments: FormControl<boolean>;
  q4OwnsTransferableSecurities: FormControl<boolean>;
  myStatementsAboveAreAccurate: FormControl<boolean>;
}

export function getInvestorStatementFormGroup(
  fb: FormBuilder
): FormGroup<investorStatementFormGroup> {
  return fb.nonNullable.group({
    q1OwnsTransferableSecurities: fb.nonNullable.control(false),
    q2OwnsCrowdfundingAssetsOrLoans: fb.nonNullable.control(false),
    q3HasCrowdfundingInvestments: fb.nonNullable.control(false),
    q4OwnsTransferableSecurities: fb.nonNullable.control(false),
    myStatementsAboveAreAccurate: fb.nonNullable.control(
      false,
      Validators.requiredTrue
    ),
  });
}

export interface knowledgeTestFormGroup {
  validStatements: FormControl<boolean>;
  understoodTheSimulation: FormControl<boolean>;
  resultReceived: FormControl<boolean>;
  availableFounds: FormControl<number>;
  financialCommitmentsValue: FormControl<number>;
  incomes: FormArray<FormGroup<IncomeTable>>;
}

export function getKnowledgeTestFormGroup(
  fb: FormBuilder
): FormGroup<knowledgeTestFormGroup> {
  return fb.nonNullable.group({
    validStatements: fb.nonNullable.control(false, Validators.requiredTrue),
    understoodTheSimulation: fb.nonNullable.control(
      false,
      Validators.requiredTrue
    ),
    resultReceived: fb.nonNullable.control(false, Validators.requiredTrue),
    incomes: getIncomeTableFormGroup(fb),
    financialCommitmentsValue: fb.nonNullable.control(0),
    availableFounds: fb.nonNullable.control(0, Validators.required),
  });
}
